define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"csi",
	"csi/action/Switchboard",
	"csi/comm",
	"csi/datasheet/Widget",
	"csi/def/Toolbar",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml"
], function(declare,lang,aspect,csi,SwitchboardAction,comm,DataSheetWidget,Toolbar,ViewRef,locale,ToolbarPluginSwitchboard,xml) {

	var _Switchboard = declare(ToolbarPluginSwitchboard, {
		idViewProperty: "sizeChartUrl",
		placeHolder: "SelectOne",
		resDefault: "",

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: not used for printing
			return !ctx.bPrint;
		}
	});

	return declare(DataSheetWidget, {
		// String: selected size chart
		sizeChartUrl: null,

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.sizeChartUrl = this.sizeChartUrl;
			return params;
		},

		getSizeChartRevision: function() {
			// summary: get currently selected size chart revision
			var	sc = this.getSizeChart();
			return sc ? this.cacheView.getNode(sc.CurrentRevision) : null;
		},

		getSizeChart: function() {
			// summary: get currently selected size chart revision
			return this.cacheView.getNode(this.sizeChartUrl);
		},

		_getRootRequest: function(/*Node*/node) {
			// summary: request for size chart rather than sample since sample is already in cache
			var request = comm.getNodeRequest(this.sizeChartUrl, null, true);
			if (request) {
				return request.addDependencyPaths(["Child:CurrentRevision/Child:Group;SizeChartSubSizeRanges;SizeRange/Child:Sizes/Child:Dimension1Size;Dimension2Size"]);
			}

			return this.inherited(arguments);
		},

		onViewStartBuild: function() {
			// summary: show error message if no size chart selected
			this.set("contentMessage", this.sizeChartUrl ? null : locale.resource("SampleSizeChartSelect"));
		},

		_resolveView: function() {
			// summary: add toolbar plugin to select size chart
			this.defView.defToolbar = lang.mixin(new Toolbar(), {
				m_actions: [
					lang.mixin(new SwitchboardAction(), {
						classToolbarPlugin: _Switchboard,
						m_id: "SelectSizeChart",
						m_viewRef: lang.mixin(new ViewRef(), {m_id: "SizeCharts"})
					})
				]
			});

			// any time the Sample node is cached, add link to selected size chart
			this.own(aspect.after(this.cacheView, "put", lang.hitch(this, function(node) {
				if (node && node.$URL == this.getViewURL()) {
					node.__SampleSizeChart__ = this.sizeChartUrl;
				}
			}), true));

			this.inherited(arguments);
		},

		_setSizeChartUrlAttr: function(/*String*/url) {
			// summary: update size chart to point to selected size chart
			this._set("sizeChartUrl", xml.isValidURL(url) ? url : null);

			var node = this.getViewNode();
			if (node) {
				node.__SampleSizeChart__ = url;
			}
		}
	});
});